import http from '../services/http'

// Authentication against the Laravel API (/api/login, Sanctum token). The legacy
// PHP login has been retired along with the rest of src/backend. The login and
// logout responses use the {access_token:[t], user_data:[json]} shape.
export default {
    state: {
        token: localStorage.getItem('access_token'),
        userDetails: localStorage.getItem('userDetails')
    },

    mutations: {
        retrieveToken(state, token) {
            state.token = token
        },
        destroyToken(state) {
            state.token = null
        },
        storeUser(state, userDetails) {
            state.userDetails = userDetails
        },
    },

    actions: {
        retrieveToken(context, credentials) {
            return http.post('/api/login', { email: credentials.email, password: credentials.password })
                .then(response => {
                    context.commit('storeUser', response.data)
                    const token = response.data.access_token[0]
                    const userDetails = JSON.parse(response.data.user_data[0])

                    context.commit('retrieveToken', token)
                    localStorage.setItem('userType', userDetails.userType)
                    localStorage.setItem('fullname', userDetails.fullname)
                    localStorage.setItem('access_token', token)
                    // Token expiry is enforced server-side (Sanctum) + the 401
                    // interceptor in services/http.js.
                    return response
                })
                .catch(error => {
                    const x = document.getElementById('snackbar')
                    if (x) {
                        x.className = 'show'
                        setTimeout(() => { x.className = x.className.replace('show', '') }, 3000)
                    }
                    throw error
                })
        },

        destroyToken(context) {
            // Revoke the token server-side (best-effort).
            if (context.state.token) {
                http.post('/api/logout').catch(() => {})
            }
            localStorage.removeItem('access_token')
            localStorage.removeItem('userType')
            localStorage.removeItem('fullname')
            localStorage.removeItem('dateTorken')
            context.commit('destroyToken')
        },
    },

    getters: {
        loggedIn(state) {
            // A valid token is required for everyone (no viewer bypass).
            return state.token !== null && state.token !== ''
        }
    }
}
